import {  push } from 'connected-react-router';
import { UPDATE_CUSTOMER_TYPE } from "../reducers/customer_type_reducer";
import { getSelectedCustomerType } from "../selectors/customer_type_selector";
import { resetCurrentCategory, reset, resetSearch } from '../actions/product';
import { isMainPage, isCategory, isSearchResult } from '../helpers/urlParts';

import { CUSTOMER_TYPE } from '../const/query_params';
import { pushWithQueryParams } from "../services/uri";

export const updateCustomerType = (customerType, resetProducts = true) => (dispatch, getState) => {
  if (getSelectedCustomerType(getState()) !== customerType) {
    const { pathname: path, search } = getState().router.location;

    dispatch({
        type: UPDATE_CUSTOMER_TYPE,
        payload: customerType,
    });

    if (!resetProducts) {
      return;
    }

    dispatch(push(path + getFullPathWithCustomerTypeQuery(window.location, customerType)));

    if (isMainPage(path)) {
      dispatch(reset());
    } else if (isSearchResult(path)) {
      dispatch(resetSearch());
    } else if (isCategory(path)) {
      dispatch(resetCurrentCategory());
    }
  }
};

const getFullPathWithCustomerTypeQuery = (url, customerType) => {
  const href = new URL(url);

  href.searchParams.set(CUSTOMER_TYPE, customerType);
  return href.search;
};



// WEBPACK FOOTER //
// ./src/actions/customer_type_actions.js